// @ts-nocheck
import { Button, Modal, Spin } from "antd";
import { useEffect, useState, useImperativeHandle } from "preact/hooks";
import { forwardRef } from "react";
import { h } from "preact";
import { useForm } from "react-hook-form";
import BaseForm from "../../../../components/form";
import { useMessage } from "../../../../hooks/useMessage";
import { FORM_MAINTENANCE_TECH_END_JOB } from "../../constants/forms";
import { IPropsModal } from "../../interface/modal";
import { ContainerConfirmGetJob, ContainerModalFooter } from "../../styled";
import { useGet } from "../../hook/useGet";
import { Text } from "../../../../components/text";
import { useSelector } from "react-redux";
import { MECHANIC_CLOSE, POST } from "../../../../services";
import { DEFAULT_STATE } from "../../constants/default-status";
import { numWithComma } from "../../../../functions";

const EndJobTech = (props: any, ref) => {
  const {
    useGetServiceOptions,
    useGetSparePartOptions,
    optionsSpar,
    setOptionsSpar,
    optionsService,
    setOptionsService,
  } = useGet();
  const userState: any = useSelector((state: IAuthState) => state.auth.user);
  const { onCallbackEdit, onBeforeConfirm } = props;
  const { openMessage } = useMessage();
  const [isMachine, setISMachine] = useState(false);
  const [visible, setVisible] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [mainId, setMaineId] = useState("");
  const [loading, setLoading] = useState(false);
  const { control, setValue, getValues, reset, handleSubmit } = useForm({
    defaultValues: DEFAULT_STATE,
  });
  const [selectedSparepart, setSelectedSparepart] = useState([]);
  const [selectedService, setSelectedService] = useState([]);

  const [summarySparepart, setSummarySparepart] = useState(0);
  const [summaryService, setSummaryService] = useState(0);

  useEffect(() => {
    if (!visible) {
      reset();
      setSummarySparepart(0);
      setSummaryService(0);
    }
  }, [visible]);

  useEffect(() => {
    useGetServiceOptions();
    useGetSparePartOptions();
  }, []);

  useImperativeHandle(ref, () => ({
    async openModal(e) {
      setISMachine(false);
      try {
        for (const key in e) {
          const element = e[key];
          if (key in DEFAULT_STATE) {
            setValue(key as keyof typeof DEFAULT_STATE, element);
          }
        }
        setValue("main_endjob_name_tech", userState.fullName);
        setValue("main_confirm_start_date", e.createDate);
        setValue("main_endjob_tech_start_date", e.createDate);
        setValue("main_endjob_tech_start_repair_date", e.createDate);
        setValue("main_endjob_tech_end_repair_date", e.createDate);
        setDeviceId(e.deviceId);
        setMaineId(e.maintainId);
        setVisible(true);
      } catch (error) {
        console.log(error);
      }
    },
  }));

  const onConfirm = async () => {
    try {
      onBeforeConfirm && (await onBeforeConfirm());
      setLoading(true);
      const {
        maintainId,
        main_endjob_remark,
        main_endjob_damage,
        main_endjob_deviceId,
        main_endjob_tech_end_link_video,
      } = getValues();
      const obj = {
        maintainId,
        remark: main_endjob_remark,
        spares: selectedSparepart.map((e) => ({
          sparePartId: e.sparePartId,
          sparePartName: e.sparePartName,
          price: +e.price,
          quantity: +e.qty,
        })),
        services: selectedService.map((e) => ({
          serviceId: e.serviceId,
          serviceName: e.serviceName,
          price: +e.price,
        })),
        cause: main_endjob_damage,
        linkVideo: main_endjob_tech_end_link_video,
        deviceId: main_endjob_deviceId,
      };

      const res = await POST(MECHANIC_CLOSE, obj);
      if (!res.success) {
        return;
      }
      openMessage("success", res.message);
      onCallbackEdit && onCallbackEdit(getValues());
      setVisible(false);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openMessage("error", (error as Error).message);
    } finally {
      setLoading(false);
    }
  };

  function onCallbackModalEdit(_, item, opt) {
    switch (item.ref) {
      case "main_endjob_tech_spare_part":
        const sumSp = opt.reduce(
          (acc, cur) => acc + (cur.qty || 1) * cur.price,
          0
        );
        setISMachine(opt.some((e) => e.isChangeDeviceNo));
        setSelectedSparepart(opt);
        setSummarySparepart(sumSp);
        return;
      case "main_endjob_tech_service":
        console.log(opt);
        const sumSv = opt.reduce((acc, cur) => acc + +cur.price, 0);
        setSelectedService(opt);
        setSummaryService(sumSv);
    }
  }

  function onCallbackModalEditSparePart(opt = []) {
    const sumSp = opt.reduce(
      (acc, cur) => acc + (+cur.qty || 1) * +cur.price,
      0
    );
    const newOpt = optionsSpar.reduce((acc, cur) => {
      const findIndex = acc.findIndex((e) => e.sparePartId === cur.sparePartId);
      if (findIndex !== -1) {
        return acc;
      }
      return [...acc, cur];
    }, opt);

    setOptionsSpar(newOpt);
    setSelectedSparepart(opt);
    setSummarySparepart(sumSp);
  }

  function onCallbackModalEditService(opt = []) {
    const sumSv = opt.reduce((acc, cur) => +acc + +cur.price, 0);
    const newOpt = optionsService.reduce((acc, cur) => {
      const findIndex = acc.findIndex((e) => e.serviceId === cur.serviceId);
      if (findIndex !== -1) {
        return acc;
      }
      return [...acc, cur];
    }, opt);
    setOptionsService(newOpt);
    setSelectedService(opt);
    setSummaryService(sumSv);
  }

  return (
    <Modal
      width={650}
      title={
        (
          <Text size={"L"} text={`ช่างปิดจบงาน #${mainId}`} bold />
        ) as React.ReactNode
      }
      visible={visible}
      okText={"บันทึก"}
      centered
      confirmLoading={loading}
      onCancel={() => setVisible(false)}
      footer={[
        <ContainerModalFooter key="1">
          <Text size={"L"} text="สรุปค่าใช้จ่ายทั้งหมด" bold />
          <Text
            size={"L"}
            text={`${numWithComma(+summarySparepart + +summaryService)} บาท`}
            bold
          />
          <Button
            type="primary"
            onClick={handleSubmit(onConfirm, (errors) => console.log(errors))}
            disabled={loading}
          >
            ปิดจบงาน
          </Button>
        </ContainerModalFooter>,
      ]}
    >
      <Spin spinning={loading}>
        <ContainerConfirmGetJob>
          <Text size={"S"} text={`หมายเลขเครืองตัด: ${deviceId}`} />
        </ContainerConfirmGetJob>
        <BaseForm
          control={control}
          forms={FORM_MAINTENANCE_TECH_END_JOB({
            isMachine,
            optionsSpar,
            optionsService,
            onCallbackEditSparePart: onCallbackModalEditSparePart,
            onCallbackEditService: onCallbackModalEditService,
          })}
          setValue={setValue}
          getValues={getValues}
          onChange={onCallbackModalEdit}
        />
      </Spin>
    </Modal>
  );
};

export const ModalEndJobTech = forwardRef<any, IPropsModal>(EndJobTech);
